import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhoSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-cream py-16 md:py-24" ref={ref} data-id="element-43">
      <div className="max-w-prose mx-auto px-5" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-45">
          <p className="font-sans text-xs tracking-[0.15em] uppercase text-sage mb-4" data-id="element-46">
            ¿Es para ti?
          </p>

          <h2 className="font-sans font-bold text-2xl md:text-3xl text-charcoal mb-10 leading-tight" data-id="element-47">
            Para quién es (y para quién no)
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="grid md:grid-cols-2 gap-6" data-id="element-48">
          {/* For you */}
          <div className="bg-sage/8 rounded-xl p-6 border border-sage/20" data-id="element-49">
            <p className="font-sans font-semibold text-sage-dark text-sm uppercase tracking-wide mb-5" data-id="element-50">
              Esto es para ti si…
            </p>
            <div className="space-y-4" data-id="element-51">
              <div className="flex items-start gap-3" data-id="element-52">
                <div className="w-5 h-5 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-53">
                  <CheckIcon className="w-3 h-3 text-sage-dark" data-id="element-54" />
                </div>
                <p className="font-serif text-base text-charcoal/85 leading-relaxed" data-id="element-55">
                  te despiertas hinchada o terminas el día como globo,
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-56">
                <div className="w-5 h-5 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-57">
                  <CheckIcon className="w-3 h-3 text-sage-dark" data-id="element-58" />
                </div>
                <p className="font-serif text-base text-charcoal/85 leading-relaxed" data-id="element-59">
                  ya probaste "comer saludable" y te sientes peor,
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-60">
                <div className="w-5 h-5 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-61">
                  <CheckIcon className="w-3 h-3 text-sage-dark" data-id="element-62" />
                </div>
                <p className="font-serif text-base text-charcoal/85 leading-relaxed" data-id="element-63">
                  quieres una guía directa, sin lácteos, sin promesas raras,
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-64">
                <div className="w-5 h-5 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-65">
                  <CheckIcon className="w-3 h-3 text-sage-dark" data-id="element-66" />
                </div>
                <p className="font-serif text-base text-charcoal/85 leading-relaxed" data-id="element-67">
                  necesitas algo que puedas sostener en vida real.
                </p>
              </div>
            </div>
          </div>

          {/* Not for you */}
          <div className="bg-warm-alt rounded-xl p-6 border border-charcoal/8" data-id="element-68">
            <p className="font-sans font-semibold text-charcoal/60 text-sm uppercase tracking-wide mb-5" data-id="element-69">
              No es para ti si…
            </p>
            <div className="space-y-4" data-id="element-70">
              <div className="flex items-start gap-3" data-id="element-71">
                <div className="w-5 h-5 rounded-full bg-charcoal/8 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-72">
                  <XIcon className="w-3 h-3 text-charcoal/40" data-id="element-73" />
                </div>
                <p className="font-serif text-base text-charcoal/60 leading-relaxed" data-id="element-74">
                  buscas una promesa médica o una cura,
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-75">
                <div className="w-5 h-5 rounded-full bg-charcoal/8 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-76">
                  <XIcon className="w-3 h-3 text-charcoal/40" data-id="element-77" />
                </div>
                <p className="font-serif text-base text-charcoal/60 leading-relaxed" data-id="element-78">
                  quieres un plan clínico 100% personalizado,
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-79">
                <div className="w-5 h-5 rounded-full bg-charcoal/8 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-80">
                  <XIcon className="w-3 h-3 text-charcoal/40" data-id="element-81" />
                </div>
                <p className="font-serif text-base text-charcoal/60 leading-relaxed" data-id="element-82">
                  no estás dispuesta a registrar 1 minuto al día (solo 1) para
                  detectar patrones.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}